import React, { useEffect } from 'react';
import find from 'lodash/find';
import isNil from 'lodash/isNil';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppContainer } from '../../components/AppContainer';
import styles from './index.module.css';
import { MerchantInfoPanel } from '../../components/MerchantInfoPanel';
import { PaymentInfoPanel } from '../../components/PaymentInfoPanel';
import { LanguageSelect } from '../../components/LanguageSelect';
import { useAppSelector } from '../../hooks/redux';
import { IMerchant } from '../../models/IMerchant';

export function MerchantPage () {
	const { id } = useParams();
	const { t, i18n } = useTranslation('translation');
	const { language } = useAppSelector(state => state.languageSlice);

	const merchant: IMerchant = useAppSelector(state => {
		return find(state.merchantReducer.merchants, m => m.id.toString() === id) || null;
	});

	useEffect(() => {
		i18n.changeLanguage(language);
	}, [language]);

	return (
		<AppContainer>
			<header className={styles.header}>
				<div className={styles.title_wrapper}>
					<Link to="/">
						<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M9 17L1 9L9 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						</svg>
					</Link>
					<h1 className={styles.title}>{t('Оплата онлайн')}</h1>
				</div>

				<LanguageSelect value={language} />
			</header>
			{!isNil(merchant)
				? (
					<div className={styles.content}>
						<PaymentInfoPanel merchant={merchant}/>
						<MerchantInfoPanel merchant={merchant}/>
					</div>
				) : <span>Merchant not found</span>}
		</AppContainer>
	);
}
